
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buying-guides",
      function () {
        return require("private-next-pages/buying-guides/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buying-guides"])
      });
    }
  